export default __webpack_public_path__ + "static/media/231.0d157e90.jpg";